import React, { useState, useEffect } from "react";

function Blank() {

  useEffect(() => {
    document.title = 'Loading';
  }, []);

  return (
    <div className="row">
      <div className="col-12 pt-4 text-center">
        <img src="/sees/dist/img/loading_spin.gif" className="img-fluid" />
      </div>
    </div>
  );
}

export default Blank;
